
import {
  ElForm,
  ElFormItem,
  ElButton,
  ElInput,
  ElMessageBox,
  ElMessage,
  ElTooltip,
  ElCheckbox,
  ElSelect,
  ElOption,
} from 'element-plus'
import { defineComponent, reactive, toRefs, ref, watch, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import api from '@/services'
import { encode } from 'js-base64'
import { $t, getUUID } from '@/Tool'
import { ElFormType } from '@/Types/ElementTypes'
import Verify from '../verifition/Verify.vue'
import { countryCode } from './countryCode'
export default defineComponent({
  name: 'emailLogin',
  components: {
    ElForm,
    ElFormItem,
    ElButton,
    ElInput,
    ElTooltip,
    ElCheckbox,
    ElSelect,
    ElOption,
    Verify,
  },
  setup(props, { emit }) {
    const checkUsername = async (rule: any, value: any, callback: any) => {
      if (!value) {
        return callback(new Error('email or telnum required'))
      }
      if (!(await checkUsernameExis(value))) {
        return callback(new Error('The current account does not exist'))
      } else {
        return callback()
      }
    }

    const checkLoginPhone = async (rule: any, value: any, callback: any) => {
      if (!value) {
        data.isSendPhoneCode = true
        return callback(new Error(`telnum required`))
      }
      if (!/^[\d]*$/.test(value)) {
        return callback(new Error('Please enter the correct telnum'))
      } else if (value.length < 5 || value.length > 18) {
        data.isSendPhoneCode = false
        return callback(new Error('Min.5 Max. 18'))
      } else if (!(await checkUsernameExis(value))) {
        data.isSendPhoneCode = false
        return callback(new Error(`The mobile number does not exist`))
      } else {
        data.isSendPhoneCode = true
        return callback()
      }
    }
    const checkPhone = async (rule: any, value: any, callback: any) => {
      if (!value) {
        data.isSendPhoneCode = true
        return callback(new Error(`telnum required`))
      }
      if (value.length < 5 || value.length > 18) {
        data.isSendPhoneCode = false
        return callback(new Error('Min.5 Max. 18'))
      } else if (await checkUsernameExis(value)) {
        if (!data.createAccount) {
          data.isSendPhoneCode = true
          data.isRegistered = false
          return callback()
        } else {
          data.isSendPhoneCode = false
          data.isRegistered = true
          return callback(new Error(`This phone number is already registered,`))
        }
      } else {
        data.isSendPhoneCode = true
        return callback()
      }
    }
    const checkEmail = async (rule: any, value: any, callback: any) => {
      if (!value) {
        data.isSendEmailCode = true
        return callback(new Error(`Email required`))
      }
      if (!data.forgetPswDisabled && (await checkUsernameExis(value))) {
        data.isSendEmailCode = false
        data.isRegistered = true
        return callback(new Error('The current mailbox is already bound'))
      } else {
        data.isSendEmailCode = true
        return callback()
      }
    }

    const checkPasswordAgain = async (rule: any, value: any, callback: any) => {
      if (!value || data.formData.password != data.formData.passwordAgain) {
        return callback(new Error('The password is not the same between the two entries'))
      } else {
        return callback()
      }
    }
    const verify = ref(null)

    const onShow = (phone) => {
      verify.value.show(phone)
    }
    const data = reactive({
      noLogin: true,
      agreeChecked: false,
      token: '',
      formData: {
        email: '',
        username: '',
        areaCode: 1,
        phone: '',
        password: '',
        verify: '',
        emailCode: '',
        registerCode: '',
        passwordAgain: '',
      },
      rules: {
        username: [
          {
            required: true,
            message: 'email or telnum required',
            trigger: 'blur',
          },
          { max: 50, message: 'Max. 50', trigger: 'blur' },
          { validator: checkUsername, trigger: 'blur' },
        ],
        password: [
          {
            required: true,
            message: 'password required',
            trigger: 'blur',
          },
          { min: 8, max: 18, message: 'Min. 6,Max. 18', trigger: 'blur' },
          {
            pattern:
              /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9-_@#$%^&?？/*、;；！!·`~……。|+=：:[\]{}<>《》""''‘’“”]{8,16}$/g,
            // pattern: /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{6,18}$/,
            // pattern: /^(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{6,18}$/,
            // pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&.,:;'])[A-Za-z\d$@$!%*#?&.,:;']{8,}$/,
            message: 'The password is 8~16 characters long and must contain numbers and letters',
          },
        ],
        verify: [
          {
            required: true,
            message: 'code required',
            trigger: 'blur',
          },
          { min: 6, max: 6, message: '6 digits', trigger: 'blur' },
        ],
        phone: [{ validator: checkLoginPhone, trigger: 'blur' }],
      },
      forgetRules: {
        phone: [
          {
            pattern: /^[\d]*$/,
            message: 'Please enter the correct telnum',
          },
          { validator: checkPhone, trigger: 'blur' },
        ],
        email: [
          {
            type: 'email',
            message: 'Please enter the correct email address',
            trigger: ['blur', 'change'],
          },
          { validator: checkEmail, trigger: 'blur' },
        ],
        verify: [
          {
            required: true,
            message: 'Code required',
            trigger: 'blur',
          },
        ],
        emailCode: [
          {
            required: true,
            message: 'code required',
            trigger: 'blur',
          },
          { min: 6, max: 6, message: '6 digits', trigger: 'blur' },
        ],
        registerCode: [
          {
            required: true,
            message: 'register code required',
            trigger: 'blur',
          },
        ],
        username: [
          {
            required: true,
            message: 'username required',
            trigger: 'blur',
          },
          { max: 50, message: '50 character', trigger: 'blur' },
        ],
        password: [
          {
            required: true,
            message: 'password required',
            trigger: 'blur',
          },

          {
            pattern:
              /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9-_@#$%^&?？/*、;；！!·`~……。|+=：:[\]{}<>《》""''‘’“”]{8,16}$/g,
            message: 'The password is 8~16 characters long and must contain numbers and letters',
          },
        ],
        passwordAgain: [
          {
            pattern:
              /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9-_@#$%^&?？/*、;；！!·`~……。|+=：:[\]{}<>《》""''‘’“”]{8,16}$/g,
            message: 'The password is 8~16 characters long and must contain numbers and letters',
          },
          { validator: checkPasswordAgain, trigger: 'blur' },
        ],
      },
      loging: false,
      clickStyle: 'clickStyle',
      CreateEmail: '',
      isClick: true, //登录为true   注册为false
      countDown: 0,
      countDownEmail: 0,
      isSendPhoneCode: true,
      isSendEmailCode: true,
      timer: 0,
      loginDisabled: true, //登录注册隐藏和显示
      forgetPswDisabled: false, //忘记密码
      isUserNameBlue: 'icon-username',
      isEmailBlue: 'icon-email',
      isPasswordBlue: 'icon-password',
      isPasswordAGBlue: 'icon-password',
      ischeckCodeBlue: 'icon-checkCode',
      ischeckEmailCodeBlue: 'icon-checkEmailCode',
      isPhoneBlue: 'icon-phone',
      isRegisterCodeBlue: 'icon-registerCode',
      codeLogin: false, //验证码登录方式
      createAccount: false,
      countryCode: countryCode,
      isRegistered: false,
    })
    const ruleForm = ref<string | ElFormType>('ruleForm') // 获取表单组件
    const reRuleForm = ref<string | ElFormType>('reRuleForm') // 获取重置密码表单组件
    const shareId = useRoute()?.query?.shareId
    //根据token免登录
    const router = useRouter()
    // const isShow = ref(false)
    //提交新密码
    const submitNewPsw = () => {
      data.loging = true
      const elform = reRuleForm.value as ElFormType
      elform.validate((valid: boolean) => {
        if (!valid) {
          data.loging = false
          return null
        }
        setPswHandle()
      })
    }
    async function setPswHandle() {
      try {
        const res: any = await resetPsw()
        if (res && res.success) {
          ElMessage({
            message: 'Password reset succeeded',
            type: 'success',
          })
          clearInput()
          data.loginDisabled = true
          // data.codeLogin = false
          data.forgetPswDisabled = false
          data.loging = false
          data.countDown = 0
          data.timer && clearInterval(data.timer)
        }
      } catch (e) {
        data.loging = false
        ElMessage({
          message: (e as string) ?? 'Account does not exist',
          type: 'warning',
        })
        clearInput()
      }
    }
    const resetPsw = async () => {
      let result: any
      try {
        result = await api.Scrm_sys_api.srcmLogin.resetPasswdByEmail({
          error: false,
          success: false,
          data: {
            email: data.formData.email,
            emailCode: data.formData.emailCode,
            passwd: encode(data.formData.password),
            // oldPasswd: encode(data.formData.passwordAgain),
          },
        })
        return Promise.resolve(result)
      } catch (e) {
        return Promise.reject(e)
      }
    }
    //忘记密码返回按钮
    const goBack = () => {
      clearInput()
      data.loginDisabled = true
      data.forgetPswDisabled = false
      data.isRegistered = false
      data.timer && clearInterval(data.timer)
      data.timer = 0
      data.countDown = 0
      data.countDownEmail = 0
    }
    //忘记密码
    const setNewPsw = (type: any) => {
      clearInput()
      data.loginDisabled = false
      data.forgetPswDisabled = true
      data.createAccount = type
      data.timer && clearInterval(data.timer)
      data.timer = 0
      data.countDown = 0
      data.countDownEmail = 0
    }

    let sessionId: string // 登陆唯一id

    //发送验证码
    async function sendMsgFn() {
      try {
        const res = await getSmsEmailVerify()
        if (res.code === '0' || 0) {
          data.countDownEmail = 10
          const timer = setInterval(() => {
            data.countDownEmail--
            if (data.countDownEmail === 0) {
              clearInterval(timer)
            }
          }, 1000)
          ElMessage({
            message: res.message ?? 'Email verification code has been sent, please check',
            type: 'success',
          })
        } else {
          ElMessage({
            message: res?.message ?? 'Email verification code sending failed',
            type: 'warning',
          })
        }
      } catch (res) {
        ElMessage({
          message: (res as string) ?? 'Email verification code sending failed',
          type: 'warning',
        })
      }
    }

    //邮箱验证码发送
    const getSmsEmailVerify = async () => {
      try {
        const result = await api.Scrm_sys_api.srcmLogin.emailVerify(
          {
            error: true,
            success: false,
            data: {
              email: data.formData.email,
            },
          },
          data.formData.email,
        )
        return Promise.resolve(result)
      } catch (e) {
        return Promise.reject(e)
      }
    }

    // 登录账号校验
    const checkUsernameExis = async (name: any) => {
      try {
        const result = await api.Scrm_sys_api.srcmLogin.usernameCheck(
          {
            error: false,
          },
          name,
        )
        if (result && result.success) {
          return Promise.resolve(result.data)
        } else {
          return Promise.resolve(true)
        }
      } catch (e) {
        return Promise.reject(e)
      }
    }
    const handleSendPhoneCode = async (type: any) => {
      if (type == 1) {
        // 手机验证码校验
        if (!data.formData.phone) {
          return ElMessage({
            message: 'Please fill in your telnum',
            type: 'warning',
          })
        }
        onShow(data.formData.phone)
      } else if (type == 2) {
        // 邮箱校验
        if (!data.formData.email) {
          return ElMessage({
            message: 'Please fill in your email',
            type: 'warning',
          })
        }
        sendMsgFn()
      }
    }
    const onSuccess = (params) => {
      if (params) {
        data.countDown = 60
        data.timer = setInterval(() => {
          data.countDown--
          if (data.countDown === 0) {
            clearInterval(data.timer)
          }
        }, 1000)
        ElMessage({
          message: 'MSM verification code has been sent, please check',
          type: 'success',
        })
      } else {
        ElMessage({
          message: 'MSM verification code sending failed',
          type: 'warning',
        })
      }
    }
    // 登陆函数
    const login = async () => {
      let result: any
      const localBrowserUniqueCode = localStorage.getItem('browserUniqueCode')
      const browserUniqueCode = localBrowserUniqueCode || getUUID()
      if (!localBrowserUniqueCode) {
        localStorage.setItem('browserUniqueCode', browserUniqueCode)
      }
      let params = {
        areaCode: data.formData.areaCode == 2 ? 1 : data.formData.areaCode,
        registerType: 5,
        source: 3,
        phone: data.formData.phone,
        email: data.formData.email ? data.formData.email : null,
        emailCode: data.formData.emailCode ? data.formData.emailCode : null,
        smsCode: data.formData.verify,
        registerCode: data.formData.registerCode,
        password: encode(data.formData.password),
        browserUniqueCode,
      }
      try {
        if (data.forgetPswDisabled && data.createAccount) {
          // 新增账户
          result = await api.Biz_api.srcmLogin.emailRegister({
            data: {
              registerType: 3,
              source: 3,
              email: data.formData.email,
              emailCode: data.formData.emailCode,
              password: encode(data.formData.password),
              browserUniqueCode,
            },
          })
        } else {
          // 登录
          result = await api.Biz_api.srcmLogin.Login(
            {
              error: true,
              success: false,
              data: {
                loginType: data.codeLogin ? 2 : 4, //	登录方式 1.账号密码登录-含图形验证码 2.手机验证码登录 3.邮箱登录 4.账号密码登录-无图形验证码
                // source: 3, //	来源 1.app 2.pc-duix官网 3.pc-口播平台
                username: data.formData.username,
                password: encode(data.formData.password),
                phone: data.formData.phone,
                smsCode: data.formData.verify,
                browserUniqueCode, // 浏览器标识
              },
            },
            sessionId,
          )
        }
        return Promise.resolve(result)
      } catch (e) {
        return Promise.reject(e)
      }
    }

    // 登陆验证
    const submitForm = () => {
      data.loging = true
      const elform = data.loginDisabled
        ? (ruleForm.value as ElFormType)
        : (reRuleForm.value as ElFormType)
      elform.validate((valid: boolean) => {
        if (!valid) {
          data.loging = false
          return null
        }
        if (!data.agreeChecked && data.loginDisabled) {
          data.loging = false
          ElMessage({
            message: 'Please read and check the user agreement and privacy policy first',
            type: 'warning',
          })
          return null
        }
        data.forgetPswDisabled && !data.createAccount ? submitNewPsw() : loginHandle()
      })
    }

    //清空输入框
    const clearInput = () => {
      ; (data.formData.username = ''),
        (data.formData.phone = ''),
        (data.formData.password = ''),
        (data.formData.passwordAgain = ''),
        (data.formData.verify = ''),
        (data.formData.areaCode = 1),
        (data.formData.email = ''),
        (data.isUserNameBlue = 'icon-username'),
        (data.isEmailBlue = 'icon-email'),
        (data.isPasswordBlue = 'icon-password'),
        (data.isPasswordAGBlue = 'icon-password'),
        (data.ischeckCodeBlue = 'icon-checkCode'),
        (data.ischeckEmailCodeBlue = 'icon-checkCode'),
        (data.isPhoneBlue = 'icon-phone')
      data.isSendPhoneCode = true
      data.isSendEmailCode = true
    }
    //vuex状态存储
    async function loginHandle() {
      try {
        const res = await login()
        const { token, userInfo } = res.object ?? {}
        if (token && userInfo) {
          //将登录信息传递给父组件
          emit('goIndex', { loginInfo: res.object, shareId: shareId, noLogin: data.noLogin })
        } else {
          ElMessage.success('register success')
          goBack()
        }
        data.loging = false
      } catch (res) {
        data.loging = false
      }
    }
    // 跳转协议/隐私
    const handleGoAgreement = (type: string) => {
      const url = `${location.origin}/vshow-main/#/${type}`
      window.open(url)
    }

    const onInputFocus = (e: any, type: string) => {
      type === 'username'
        ? (data.isUserNameBlue = 'icon-username_blue')
        : (data.isUserNameBlue = 'icon-username')
      type === 'password'
        ? (data.isPasswordBlue = 'icon-password_blue')
        : (data.isPasswordBlue = 'icon-password')
      type === 'passwordAg'
        ? (data.isPasswordAGBlue = 'icon-password_blue')
        : (data.isPasswordAGBlue = 'icon-password')
      type === 'checkCode'
        ? (data.ischeckCodeBlue = 'icon-checkCode_blue')
        : (data.ischeckCodeBlue = 'icon-checkCode')
      type === 'registerCode'
        ? (data.isRegisterCodeBlue = 'icon-registerCode_blue')
        : (data.isRegisterCodeBlue = 'icon-registerCode')
      type === 'emailCode'
        ? (data.ischeckEmailCodeBlue = 'icon-checkCode_blue')
        : (data.ischeckEmailCodeBlue = 'icon-checkCode')
      type === 'email' ? (data.isEmailBlue = 'icon-email_blue') : (data.isEmailBlue = 'icon-email')
      type === 'phone' ? (data.isPhoneBlue = 'icon-phone_blue') : (data.isPhoneBlue = 'icon-phone')
    }
    return {
      ...toRefs(data),
      ruleForm,
      submitForm,
      sendMsgFn,
      setNewPsw,
      goBack,
      submitNewPsw,
      reRuleForm,
      onInputFocus,
      handleGoAgreement,
      handleSendPhoneCode,
      onShow,
      verify,
      onSuccess,
    }
  },
})
